import React from 'react';
import styled from 'styled-components';
import { Col } from 'styled-bootstrap-grid';

import ListIcon from '../icons/list-icon';
import CalendarIcon from '../icons/calendar-icon';

const ViewOption = styled.button`
  max-width: 230px;
  width: 100%;
  height: 50px;

  cursor: pointer;

  border-radius: 25px;
  border: 0;

  background-color: #000;
  color: #fff;

  padding: 0;
  margin: ${props => (props.marginAuto ? '0 auto' : '0') || '0 auto'};

  line-height: 47px;
  font-size: 20px;

  &:hover {
    background-color: #000;
  }

  display: flex;
  justify-content: center;

  @media (max-width: 767px) {
    max-width: 170px;
    width: 100%;

    height: 40px;

    line-height: 39px;
    font-size: 16px;
  }

  @media (max-width: 600px) {
    display: none;
  }
`;

const ActiveViewOption = styled(ViewOption)`
  background-color: #3c82e6;

  @media (max-width: 600px) {
    display: none;
  }
`;

const TimetableView = ({ onClick, activeButton }) => {
  return (
    <React.Fragment>
      <Col col={6} sm={4}>
        {activeButton === 'List' ? (
          <ViewOption onClick={() => onClick('List')}>
            <ListIcon fill={'#fff'} />
            List View
          </ViewOption>
        ) : (
          <ActiveViewOption onClick={() => onClick('List')}>
            <ListIcon fill={'#fff'} />
            List View
          </ActiveViewOption>
        )}
      </Col>
      <Col col={6} sm={4}>
        {activeButton === 'Calendar' ? (
          <ViewOption onClick={() => onClick('Calendar')} marginAuto={true}>
            <CalendarIcon fill={'#fff'} />
            Calendar View
          </ViewOption>
        ) : (
          <ActiveViewOption
            onClick={() => onClick('Calendar')}
            marginAuto={true}
          >
            <CalendarIcon fill={'#fff'} />
            Calendar View
          </ActiveViewOption>
        )}
      </Col>
    </React.Fragment>
  );
};

export default TimetableView;
